<template>
  <!-- 表单-Start -->
  <a-drawer
    v-if="visible"
    :z-index="zIndex"
    wrap-class-name="c-form-drawer"
    :width="`${width}`"
    placement="right"
    :visible="visible"
    :closable="false"
    :mask-closable="false"
    :get-container="getContainer"
    @close="handleDrawerClose"
  >
    <!-- <b-sidebar
    v-model="visible"
    bg-variant="white"
    :width="`${width}`"
    right
    backdrop
    shadow
    no-header
    no-close-on-backdrop
    no-close-on-esc
  > -->
    <template>
      <div class="sidebar-header">
        {{ title }}
        <span class="sidebar-header__close" @click="$emit('beforeClose')"
          ><feather-icon icon="XIcon" size="18" />
        </span>
      </div>
      <template v-if="!custom">
        <!-- :width="width" -->
        <my-form
          v-if="optionChange"
          :loading="loading"
          :data="data"
          :option="option"
          :page-key="pageKey"
          :width="width"
          @submit="handleSubmit(pageKey, $event)"
          @reset="handleReset(pageKey, $event)"
        >
          <template v-for="slotName in formSlotItems" :slot="slotName">
            <slot :name="slotName" />
          </template>
        </my-form>
      </template>
      <template v-else>
        <slot :name="`${pageKey}Drawer`" />
      </template>
    </template>
    <!-- </b-sidebar> -->
  </a-drawer>
  <!-- 表单_End -->
</template>

<script>
import { BSidebar } from 'bootstrap-vue'
import MyForm from '../myForm/index.vue'

export default {
  name: 'CForm',
  components: { MyForm },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '500',
    },
    // width: {
    //   type: String,
    //   default: 'auto',
    // },
    title: {
      type: String,
      default: 'Form',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    pageKey: {
      type: String,
      default: 'add',
    },
    custom: {
      type: Boolean,
      default: false,
    },
    zIndex: {
      type: Number,
      default: 1032,
    },
    container: {
      type: [Object, Boolean],
      default: false,
    },
  },
  data() {
    return {
      columns: this.option.columns || [],
      optionChange: true,
      defaultOverflowY: 'auto',
    }
  },
  computed: {
    formSlotItems() {
      const slots =
        this.columns.filter((o) => {
          if (o.formOption) {
            if (o.formOption.slot) return o
          }
          return false
        }) || []
      return slots.map((o) => `${o.field}Form`)
    },
  },
  watch: {
    visible(e) {
      setTimeout(() => {
        document.body.style.overflowY = e ? 'hidden' : this.defaultOverflowY
      }, 10)
    },
    option: {
      handler(e) {
        this.columns = e.columns
        // this.optionChange = false
        // setTimeout(() => {
        //   this.optionChange = true
        // }, 10);
      },
    },
  },
  created() {
    this.defaultOverflowY = document.body.style.overflowY
  },
  methods: {
    handleSubmit(key, e) {
      console.log('ss', key, e)
      this.$emit('submit', key, e)
    },
    handleReset(key, e) {
      this.$emit('reset', key, e)
    },
    handleDrawerClose() {
      this.$emit('update:visible', false)
      this.visible = false
    },
    getContainer() {
      return this.container || document.body
    },
  },
}
</script>

<style lang="scss">
.c-form-drawer {
  .sidebar-header {
    padding: 20px;
    font-size: 22px;
    border-bottom: 1px solid #ebe9f1;
    position: relative;
    &__close {
      position: absolute;
      right: 25px;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
    }
  }
  .ant-drawer-body {
    padding: 0;
    height: 98%;
  }
  .my-form {
    height: calc(100% - 72px);
  }
}

.dark-layout {
  .c-form-drawer {
    .ant-drawer-content {
      background: #283046;
    }
  }
}
</style>
